import React from "react";
import Select, { components } from "react-select";
import DropdownArrowDown from "./img/dropdownArrow-Down.svg";
import DropdownCloseIcon from "./img/close-icon.svg";

/* Default Dropdown Arrow */
const DefaultDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <img
      src={DropdownArrowDown}
      alt="Dropdown Arrow"
      width={10}
      className="SwSelect_DD_Arrow"
    />
  </components.DropdownIndicator>
);

/* Default Clear Icon */
const DefaultClearIndicator = (props) => (
  <components.ClearIndicator {...props}>
    <img
      src={DropdownCloseIcon}
      alt="Clear"
      width={12}
      style={{ cursor: "pointer" }}
    />
  </components.ClearIndicator>
);

/* Default Styles */
const defaultStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#1E1E2D"
      : state.isFocused
      ? "#F4F4F5"
      : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    "&:hover": {
      backgroundColor: state.isSelected ? "#1E1E2D" : "#323242",
    },
  }),
};


const SwSelect = ({
  /* Core */
  options = [], // array of options
  value, // selected value
  onChange, // on change handler

  /* Behaviour */
  isMulti = false,  // true or false
  isClearable = true, // true or false
  placeholder = "Select an option...",

  /* Customisation */
  styles, // custom styles
  components: customComponents, // custom components
  className = "", // custom class name
  isDisabled = false, // true or false

  /* Forward props */
  ...rest
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      isMulti={isMulti}
      isClearable={isClearable}
      placeholder={placeholder}
      className={`SwSelect ${className}`.trim()}
      styles={styles || defaultStyles}
      components={{
        DropdownIndicator: DefaultDropdownIndicator,
        ClearIndicator: DefaultClearIndicator,
        IndicatorSeparator: () => null,
        ...customComponents,
      }}
      isDisabled={isDisabled}
      {...rest}
    />
  );
};

export default SwSelect;
